var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_414_20296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0086 22.0517C20.113 22.6488 19.0726 22.9644 18 22.9644C16.9275 22.9644 15.8871 22.6488 14.9915 22.0517L0.239695 12.2169C0.15826 12.1624 0.0783312 12.1058 0 12.0469L0 28.1624C0 30.01 1.49941 31.4764 3.31404 31.4764H32.6859C34.5336 31.4764 35.9999 29.977 35.9999 28.1624V12.0469C35.9215 12.1059 35.8414 12.1626 35.7597 12.2172L21.0086 22.0517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40977 10.4635L16.1615 20.2984C16.72 20.6707 17.3599 20.8568 17.9999 20.8568C18.64 20.8568 19.28 20.6706 19.8385 20.2984L34.5902 10.4635C35.473 9.87534 36 8.89096 36 7.82854C36 6.00175 34.5138 4.51562 32.6871 4.51562H3.31292C1.4862 4.5157 1.74382e-06 6.00182 1.74382e-06 7.8303C-0.000545892 8.35146 0.127901 8.86465 0.373885 9.32411C0.619869 9.78357 0.975743 10.175 1.40977 10.4635Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_414_20296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.04828645649eec72aad9af89840fe25c.svg";
export { ForwardRef as ReactComponent };